<template>
    <div v-if="!showMessage">
        <article
            class="message px-0 py-0"
        >
            <div
                id="session_list"
                class="message-body px-0 py-0 is-radiusless"
            >
                
                <div class="message-body-content px-0 py-0">
                    <l-project-sessions-list :sessions="sessions"/>
                </div>
            </div>
        </article>
    </div>
    <div v-else>
        <div class="no-game-list">
            <p class="">{{ $t('no_sessions') }}</p>
        </div>
    </div>
</template>

<script>
import { fetchItems, updateItem } from '@/services/API';
import _ from 'underscore';
import LProjectSessionsList from '@/components/LProjectSessionsList';
export default {
    components: {
        LProjectSessionsList
    },
    props: {
        activeSession: { type: Object, default: {} },
    },
    data() {
        return { sessions: [], session: {} };
    },
    filters: {
        createdDate(timestamp) {
            return moment(timestamp).format('DD/MM/YYYY');
        },
    },
    computed: {
        project() {
            return this.$store.getters.project;
        },
        editing() {
            // console.log(this.session, this.session._id);
            return this.session._id ? true : false;
        },

        isAdmin() {
            return this.$store.getters.isAdmin;
        },
        hasActiveSession(){
            return this.activeSession.length;
        },
        isModeMap() {
            return this.$store.getters.project.mode == 'map';
        },
        isWeb() {
            // console.log('isWeb', this.session.configuration.web === true);
            return (
                this.activeSession.configuration.web &&
                !this.activeSession.configuration.app
            );
        },
        showMessage(){
            return !this.sessions.length || (this.sessions.length==1 && this.sessions[0].isActive )
        },
        isApp() {
            // console.log('isApp', this.session.configuration.app === true);
            return (
                this.activeSession.configuration.app &&
                !this.activeSession.configuration.web
            );
        },
        isTrivial() {
            return this.$store.getters.project.type == 'trivial';
        },
    },
    async mounted() {
        let response = await fetchItems(
            `session/mine?project=${this.project._id}`
        ).finally(() => { });
        let totalSessions = response.data;
        totalSessions.forEach(session => {
            if (session.isArchived) {
                this.sessions.push(session);
            }
        });
        //this.sessions = response.data;

        // console.log("sessions",this.sessions);
        /*this.$nextTick(() => {
            const collapsibles = bulmaCollapsible.attach();
        });*/
    },
    methods: {
        
        
        
    },
};
</script>

<style scoped>
@import '../assets/css/leftPanel.css';
.message {
    background-color: transparent;
    border-radius: 0;
    font-size: 1rem;
    margin-bottom: 0;
    overflow-y: auto;
    max-height: calc(100vh - 45px);
    overflow-x: hidden;
}

.message
    a:not(.button):not(.lb-button):not(.lb-toolbar-button_images):not(.lb-toolbar-button_video):not(.lb-toolbar-button_files):not(.lb-toolbar-button_audio):not(.lb-toolbar-button_url):not(.lb-toolbar-button_location):not(.lb-toolbar-button_tags):not(.lb-toolbar-button_question):not(.lb-toolbar-button_object):not(.lb-toolbar-button_point):not(.lb-delete-media):not(.lb-answer):not(.lb-multiple-answer):not(.tag):not(.lb-bain-tag-functional):not(.lb-bain-tag-emotional):not(.lb-bain-tag-life-changer):not(.lb-bain-tag-social-impact):not(.lb-role-tag_administrator):not(.lb-role-tag_teacher):not(.lb-role-tag_student):not(.lb-role-tag_coordinator):not(.lb-role-tag_participant):not(.lb-role-tag_facilitator):not(.lb-status-tag_active):not(.lb-status-tag_inactive):not(.lb-status-tag_invited):not(.dropdown-item) {
    text-decoration: none;
}
.message-body {
    overflow-x: hidden;
    border-left-style: hidden;
}

.button.is-multiline {
  min-height: 2.25em;
  white-space: unset;
  height: auto;
  flex-direction: column;
}

.bottom-full-button{
    position: absolute;
    bottom: 0;
    border-radius: 0px;
    width: 100%;
}
.no-game-list{
    background-color: var(--eduloc-red);
    padding: 1rem;
    color: #FFFFFF;
    font-family: var(--secondary-font);
    font-size: 1.1rem;
}
</style>
